export const textFromSelector = (selector: string, defaultText: string) => {
  const value = document.querySelector(selector)?.textContent?.trim()

  let title = !!value ? value : defaultText
  return title
}
